import actions from '../actions';
import {
    Link,
    Panel,
    React
} from '../common';

export const PhoneItem = ({
    item,
    details,
    trackingAlias,
}) => (
    <Panel>
        <Link
            href={() => actions.dial(item)}
            trackingAlias={trackingAlias || 'tel_registry'}
            trackingParams={{ ...details }}
        >
            {item}
        </Link>
    </Panel>
);
